export const GET_VEHICLE_AS_LOG = "GET_VEHICLE_AS_LOG";

export const CLEAR_VEHICLE_AS_LOG = "CLEAR_VEHICLE_AS_LOG";
export const SET_VEHICLE_AS_LOG_LOADING_STATUS = 'SET_VEHICLE_AS_LOG_LOADING_STATUS'